<template>
  <li class="nav-item dropdown notification-list custom-notification-list">
    <a class="nav-link dropdown-toggle arrow-none waves-light waves-effect" v-on:click="setSeen" data-toggle="dropdown"
       href="#"
       role="button"
       aria-haspopup="false" aria-expanded="false">
      <el-tooltip :value="unSeenReminders.length > 0" :manual="true" class="item" content="Vous avez des rappels de rendez-vous en attente." placement="bottom">
        <span>
          <i class="zmdi zmdi-notifications-none noti-icon"></i>
          <span v-if="unSeenReminders.length > 0" class="noti-icon-badge"></span>
        </span>
      </el-tooltip>
    </a>
    <div class="dropdown-menu dropdown-menu-right dropdown-arrow dropdown-lg" aria-labelledby="Preview">
      <!-- item-->
      <div class="dropdown-item noti-title">
        <h5>
          <small>
            <span v-if="unSeenReminders.length > 0" class="label label-danger pull-xs-right">{{ unSeenReminders.length
              }}</span>
            Rappels (rendez-vous)
          </small>
        </h5>
      </div>
      <a v-for="reminder in models.reminders" :href="'#/customers/' + reminder.customer_id"
         v-bind:class="'dropdown-item notify-item ' + [reminder.seen ? '' : 'not-seen']">
        <div class="edit-button" @click="setNotDisplayed(reminder.id); return false;" style="cursor: pointer">
          <i class="fa fa-times"></i>
        </div>
        <p class="notify-details">
          <strong :style="{'color': reminder.category.color}">{{ reminder.category.name }}</strong>
          <br /><customer :item="models.customers.find(customer => customer.id === reminder.customer_id)" present="name"></customer>
          <small class="text-muted">Rendez-vous {{ reminder.date.date | moment("from", "now") }}</small>
        </p>
      </a>
      <a v-if="models.reminders.length === 0" class="dropdown-item notify-item">
        <p class="notify-details">Aucun rappel non lu</p>
      </a>
      <router-link to="/reminders" class="dropdown-item notify-item notify-all" style="padding-top: 10px !important;">
        Voir tous les rappels
      </router-link>
    </div>
  </li>
</template>

<script>
  import Reminder from '@db2b/keystone/components/Entities/Reminder.vue'
  import Customer from '@db2b/keystone/components/Entities/Customer.vue'
  import Vue from 'vue'

  export default {
    components: {
      Customer,
      Reminder
    },
    name: 'top-bar-alert',
    data () {
      return {
        models: {
          reminders: [],
          customers: []
        }
      }
    },
    sync: {
      models: {
        reminders () {
          let self = this

          return {
            name: 'reminder',
            onCreate ({index, data, model}) {
              if (model.user_id === self.$store.getters['users/current'].id && index === -1) data.push(model)
            },
            onUpdate ({index, data, model}) {
              if (index !== -1) {
                if (model.meeting_displayed) {
                  Vue.set(data, index, model)
                } else {
                  data.splice(index, 1)
                }
              } else {
                if (model.user_id === self.$store.getters['users/current'].id && model.meeting_displayed === 1) {
                  data.push(model)
                }
              }
            }
          }
        },
        customers: 'customer'
      }
    },
    computed: {
      unSeenReminders () {
        return this.models.reminders.filter(reminder => !reminder.meeting_seen)
      }
    },
    methods: {
      setSeen () {
        this.$nexus.post('callcenter', 'reminders/seen')
      },
      setNotDisplayed (id) {
        this.$nexus.put('callcenter', 'reminders/' + id, {
          meeting_displayed: 0
        })
      }
    },
    created () {
      let self = this

      this.$nexus.get('callcenter', 'reminders', {
        params: {
          where: {
            user_id: this.$store.getters['users/current'].id,
            meeting_displayed: 1
          }
        }
      }).then(response => {
        self.models.reminders = response.data.data
      })

      this.$sync.on('reminder:notify', (event) => {
        if (event.model.user_id === this.$store.getters['users/current'].id) {
          this.$notify.success({
            title: 'Rappel de rendez-vous',
            dangerouslyUseHTMLString: true,
            message: event.meta.summary + '<br /><a href="#/customers/' + event.model.customer_id + '">Voir la fiche</a>',
            duration: 0
          })
        }
      })
    },
    watch: {
      'models.reminders' () {
        let self = this

        this.$model.customer.getFromRelations(self.models.reminders).then(customers => {
          self.models.customers = customers
        })
      }
    },
    mounted () {
      let self = this

      setInterval(() => {
        self.$forceUpdate()
      }, 30000)
    }
  }
</script>

<style>
  .notify-details {
    margin-left: 0 !important;
    padding-top: 10px;
  }

  .notify-item {
    position: relative;
    padding-top: 0 !important;
  }

  .notify-item .edit-button {
    float: right;
    width: 0%;
    height: 100%;
    color: white;
    background-color: #ff5d48;
    opacity: 0.5;
    position: relative;
  }

  .notify-item:hover .edit-button {
    transition: 0.1s;
    width: 15%;
    position: absolute;
    right: 0;
  }

  .notify-item .edit-button i {
    font-size: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .notify-item:hover .edit-button i {
    transition: 0.1s;
    font-size: 1.5em;
  }
</style>



// WEBPACK FOOTER //
// TopBarAlert.vue?4f50f9c0